import React, { useEffect, useState } from 'react'; 
import ListTemplate from '../../../Reusable_Components/ListTemplate';  
import axios from 'axios'; 
import { API_ROUTES, API_DOMAIN, headers } from '../../../Reusable_Components/apiConfig';  

const AssetListDetails = () => { 
  const [assets, setAssets] = useState([]); 

  useEffect(() => { 
    const fetchAssets = async () => { 
      try { 
        const url = `${API_DOMAIN}${API_ROUTES.asset}`; 
        const token = localStorage.getItem('token'); 
         
        const response = await axios.get(url, { headers }); 
        setAssets(response.data); 
      } catch (error) { 
        console.error('Error fetching assets:', error); 
      } 
    }; 

    fetchAssets(); 
  }, []); 

  const columns = [ 
    { label: 'Asset Name', value: 'name' }, 
    { label: 'Purchase Date', value: 'purchase_date' }, 
    { label: 'Purchase Price', value: 'purchase_price' }, 
    { label: 'Useful Life Years', value: 'useful_life_years' }, 
    { label: 'Depreciation Rate', value: 'depreciation_rate' }, 
    { label: 'Current Value', value: 'current_value' }, 
    { label: 'Asset Type', value: 'asset_type' }, 
  ]; 

  const handleViewDetails = (assetId) => { 
    //console.log('View Details', assetId); 
    const encodedId = btoa(assetId);
    window.location.href = `/asset/details/${encodedId}`; 
  }; 

  const actionButtons = [ 
    { label: 'View Details', handler: handleViewDetails }, 
  ]; 

  return <ListTemplate columns={columns} data={assets} actionButtons={actionButtons} />; 
}; 

export default AssetListDetails;